import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 1H3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h1v3.14a.86.86 0 0 0 1.396.671L10.158 14H15a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m0 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H9.456l-.548.438L6 14.766V12H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-1 5H4v1h10zm0-3H4v1h10z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
